import API from '../api/axios';
const sendOtp = async (formData, nextStep, setMessage) => {
    const otpResponse = await API.post("/sendEmailOtp", {
      auth_user_phone_number: formData.mobileNumber,
      email: formData.email,
    });
  
    if (otpResponse.data && otpResponse.data.success) {
      setMessage({ type: "success", text: "OTP sent to your email" });

      nextStep(); // Use the passed function
    } else {
    //   alert(otpResponse.data.message || "Failed to send OTP");
      setMessage({ type: "error", text: otpResponse.data.message});
    }
  };
  
  export default sendOtp;